"use client"

import { useState, useEffect } from "react"
import { Button } from "@/components/ui/button"
import { X } from "lucide-react"
import { useLocalStorage } from "@/hooks/use-local-storage"

export default function CookiesConsent() {
  const [showConsent, setShowConsent] = useState(false)
  const [cookiesConsent, setCookiesConsent] = useLocalStorage<string | null>("cookies-consent", null)

  useEffect(() => {
    if (!cookiesConsent) {
      setShowConsent(true)
    }
  }, [cookiesConsent])

  const acceptCookies = () => {
    setCookiesConsent("accepted")
    setShowConsent(false)
  }

  const declineCookies = () => {
    setCookiesConsent("declined")
    setShowConsent(false)
  }

  if (!showConsent) return null

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 z-50 shadow-lg animate-in slide-in-from-bottom duration-300">
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex-1">
          <p className="text-sm text-gray-600">
            We use cookies to enhance your experience on our website. By continuing to use this site, you consent to our use of cookies.{" "}
            <a href="/privacy-policy" className="text-green-600 hover:underline font-medium">
              Learn more
            </a>
          </p>
        </div>
        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={declineCookies}
            className="text-gray-600 hover:bg-gray-50"
          >
            Decline
          </Button>
          <Button
            size="sm"
            onClick={acceptCookies}
            className="bg-green-600 hover:bg-green-700 text-white"
          >
            Accept All
          </Button>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={declineCookies}
          className="absolute top-2 right-2 p-1 h-auto hover:bg-gray-100"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  )
} 